
import React from 'react';
import { Dupe } from '../types';
import { Sparkles } from 'lucide-react';

interface DupesSectionProps {
  dupes: Dupe[];
}

const DupesSection: React.FC<DupesSectionProps> = ({ dupes }) => {
  if (!dupes || dupes.length === 0) return null;

  return (
    <section className="py-24 bg-brand-cream/20 border-y border-brand-black/5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles size={16} className="text-brand-gold animate-pulse" />
            <span className="text-[10px] uppercase tracking-[0.6em] text-brand-gold font-bold">Le Guide des Correspondances</span>
            <Sparkles size={16} className="text-brand-gold animate-pulse" />
          </div>
          <h2 className="font-serif text-4xl md:text-6xl text-brand-black mb-6">Nos "Dupes" Préférés</h2>
          <p className="text-brand-black/60 text-sm font-light max-w-2xl mx-auto italic">
            Trouvez votre fragrance signature parmi nos correspondances exclusives. 
            Le même sillage, une nouvelle expérience sensorielle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {dupes.map((dupe) => (
            <div key={dupe.id} className="group relative overflow-hidden rounded-[2rem] bg-white shadow-sm border border-brand-black/5 luxury-transition hover:shadow-xl hover:-translate-y-1">
              <div className="aspect-[4/5] overflow-hidden">
                <img 
                  src={dupe.image} 
                  alt={dupe.title} 
                  className="w-full h-full object-cover luxury-transition group-hover:scale-105"
                  referrerPolicy="no-referrer"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-brand-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 luxury-transition flex flex-col justify-end p-8">
                <p className="text-brand-offwhite text-[10px] uppercase tracking-widest font-bold mb-2">Correspondance</p>
                <h3 className="font-serif text-2xl text-white">{dupe.title}</h3>
              </div>
              {/* Overlay permanent discret pour mobile */}
              <div className="md:hidden absolute bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-sm border-t border-brand-black/5">
                 <p className="text-[9px] uppercase tracking-widest font-bold text-brand-gold">{dupe.title}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="inline-block p-1 rounded-full bg-brand-gold/10 border border-brand-gold/20">
            <div className="px-6 py-2 rounded-full bg-brand-offwhite border border-brand-gold/30">
              <p className="text-[9px] uppercase tracking-[0.3em] font-bold text-brand-black">
                Mise à jour régulière selon les arrivages
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DupesSection;
